// import VT from '@/store/types';

export default {
  // [VT.AI_JOBS_LIST]: (state, { data, status }) => {
  //   state.aiJobsList = { data, status };
  // },
};
